import { render, staticRenderFns } from "./matchTheFollowing.vue?vue&type=template&id=03c022b4&"
import script from "./matchTheFollowing.vue?vue&type=script&lang=js&"
export * from "./matchTheFollowing.vue?vue&type=script&lang=js&"
import style0 from "./matchTheFollowing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports